// The URL path this app is mounted at, always with a trailing slash.
// At the domain root this is "/"; on a subpath mount (e.g. the preview
// deployment) it is "/preview-moneytrack/". Derived from the document URL so
// the same build serves correctly wherever nginx mounts it — no hardcoded base.
export function basePath(): string {
  return new URL('./', location.href).pathname;
}
